const data = {
  id: 1,
  title: 'Read and tick T or F.',
  subTitle: 'Đọc và chọn đúng hoặc sai.',
  audioUrl: '',
  imageUrl: '',
  questionText: 'Hi. My name is Xuka. I am from Tokyo, Japan. I am Japanese. I am in Ha Noi now. I have many friends. They are from different countries. Mai is from Viet Nam. She is Vietnamese. Tom is from England. He is English. Peter is from Malaysia. He is Malaysian.',
  question: '',
  answers: [
    { answer: 'Xuka is from Japan.', isCorrect: true },
    { answer: 'Xuka has many friends in England.', isCorrect: false },
    { answer: 'Peter is from England.', isCorrect: false },
  ],

};

export default data;
